// export const BASE_URL = 'http://localhost/shiv_mfg_api/public/'
// export const BASE_URL = 'https://c6lgd.kodllin.com/apis/public/'
// export const BASE_URL = 'https://yashokrupamfg.kodllin.com/apis/public/'
// export const BASE_URL = 'https://marutimfg.kodllin.in/apis/public/'
export const BASE_URL = 'https://saumyamfg.kodllin.in/apis/public/'
// export const BASE_URL = 'https://sj.kodllin.com/apis/public/'
// export const BASE_URL = 'https://shivgems.kodllin.com/apis/public/'
// export const BASE_URL = 'https://dhanushlgd.kodllin.com/apis/public/'
// export const BASE_URL = 'https://khodiyardiam.kodllin.com/apis/public/'
// export const BASE_URL = 'https://mfg.stavyaexports.com/apis/public/'
// export const BASE_URL = 'https://aksharmfg.kodllin.com/apis/public/'
// export const BASE_URL = 'https://santkrupa.kodllin.com/apis/public/'
// export const BASE_URL = 'https://diarisetest.dkinfoway.com/apis/public/'
// export const BASE_URL = 'https://bluemoonapi.dkinfoway.com/'
// export const BASE_URL = 'http://127.0.0.1:8000/api'

// export const BASE_URL_REPORT = 'https://gg.kodllin.com/'
// export const BASE_URL_REPORT = 'https://yashokrupareports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://marutimfgreports.kodllin.in/'
export const BASE_URL_REPORT = 'https://saumyamfgreports.kodllin.in/'
// export const BASE_URL_REPORT = 'https://shivgemsreports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://sjreports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://dhanushlgdreports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://khodiyardiamreports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://reports.stavyaexports.com/'
// export const BASE_URL_REPORT = 'https://aksharreports.kodllin.com/'
// export const BASE_URL_REPORT = 'https://santkrupareports.kodllin.com/'
// export const BASE_URL_REPORT = 'http://localhost:5173/'
// export const BASE_NAME = 'SJ Diamonds'
// export const BASE_NAME = 'KODLLIN'
// export const BASE_NAME = 'C6LGD'
// export const BASE_NAME = 'Yashokrupa'
// export const BASE_NAME = 'MARUTI EXPORTS'
export const BASE_NAME = 'SAUMYA MANUFACTURING'
// export const BASE_NAME = 'Shivratna Gems'
// export const BASE_NAME = 'Dhanush Labgrown Diamond'
// export const BASE_NAME = 'Khodiyar Diamond'
// export const BASE_NAME = 'Stavya Exports'
// export const BASE_NAME = 'AKSHAR DIAGEMS'
// export const BASE_NAME = ' SANTKRUPA DIAMOND'

// export const BARCODE_LABEL = "Ghetiyagems"
// export const BARCODE_LABEL = "Yashokrupa"
// export const BARCODE_LABEL = "Ghetiyagems"
// export const BARCODE_LABEL = "C6LGD"
// export const BARCODE_LABEL = "MARUTI EXPORT"
export const BARCODE_LABEL = "SAUMYA MANUFACTURING"
// export const BARCODE_LABEL = "KODLLIN"
// export const BARCODE_LABEL = "SANTKRUPA"
// export const BARCODE_LABEL = "STAVYA"
// export const BARCODE_LABEL = "GEMPROWESS"
// export const BARCODE_LABEL = "DHANUSH"
// export const BARCODE_LABEL = "OMJ"
// export const BARCODE_LABEL = "SJ"
